import { useEffect, useState } from "react";
import useGetCensusParams from "./GetCensusParams";
import { useLayerService } from "../../../../../hooks";
import CensusUrlKeys from "../../../../../constant/CensusUrlKeys";
import YearDropdown from "../../../../boundarySelection/ViewTools/YearDropdown";
import { useViewContext } from "../../../../../context/View/ViewContext";
import CensusYearModal from "./CensusYearModal";
import { intersects } from "ol/extent";

const SCOTLAND_EXTENT: [number, number, number, number] = [
  -950000, 7200000, 100000, 8650000,
];

const ENGLAND_WALES_EXTENT: [number, number, number, number] = [
  -642376, 6437484, 203683, 7497888,
];

const YEAR_MODAL_CONFIG: Record<
  number,
  { message: string; extent: [number, number, number, number] }
> = {
  2022: {
    message: "The 2022 Census was conducted for Scotland.",
    extent: SCOTLAND_EXTENT,
  },
  2021: {
    message: "The 2021 Census was conducted for England and Wales.",
    extent: ENGLAND_WALES_EXTENT,
  },
};

const CensusYearDropdown = () => {
  const layerService = useLayerService();
  const [years, setYears] = useState<number[]>([]);
  const { year, handleSelect } = useGetCensusParams();
  const { view } = useViewContext();
  const [modalYear, setModalYear] = useState<number | null>(null);

  useEffect(() => {
    layerService.GetCensusReleaseYears().then((response) => {
      setYears(response);
      if (year === null && response.length > 0) {
        handleSelect(CensusUrlKeys.YEAR, Math.min(...response));
      }
    });
  }, [layerService]);

  const onChange = (selectedYear: number) => {
    handleSelect(CensusUrlKeys.YEAR, selectedYear);
    if (YEAR_MODAL_CONFIG[selectedYear]) {
      const currentExtent = view.calculateExtent();
      if (!intersects(currentExtent, YEAR_MODAL_CONFIG[selectedYear].extent)) {
        setModalYear(selectedYear);
      }
    }
  };

  const handleFitMap = () => {
    if (modalYear !== null) {
      view.fit(YEAR_MODAL_CONFIG[modalYear].extent, { duration: 500 });
    }
  };

  const activeModal = modalYear !== null ? YEAR_MODAL_CONFIG[modalYear] : null;

  return (
    <>
      <YearDropdown
        year={year}
        onYearChange={onChange}
        years={years}
        yearLabels={{ 2022: "2022 - Scotland" }}
      />
      {activeModal && (
        <CensusYearModal
          show={!!activeModal}
          message={activeModal.message}
          onFitMap={handleFitMap}
          onClose={() => setModalYear(null)}
        />
      )}
    </>
  );
};

export default CensusYearDropdown;
